import { IStyle } from "./../../../Types/Style";
import { createAction } from "redux-actions";

import { IPatchPayload } from "../../../components/course-author/helpers/patches";
import { ICompleteOrganization, IFontFamily } from "../../types/common";

export enum Action {
  ADD_NEW_LOGO = "THEME_MANAGEMENT/ADD_NEW_LOGO",
  HANDLE_ADD_NEW_LOGO_SUCCESS = "THEME_MANAGEMENT/HANDLE_ADD_NEW_LOGO_SUCCESS",
  HANDLE_ADD_NEW_LOGO_FAILURE = "THEME_MANAGEMENT/HANDLE_ADD_NEW_LOGO_FAILURE",
  DISMISS_PATCH_ALERTS = "THEME_MANAGEMENT/DISMISS_PATCH_ALERTS",
  PATCH_STYLE = "THEME_MANAGEMENT/PATCH_STYLE",
  HANLDE_PATCH_STYLE_FAILURE = "THEME_MANAGEMENT/HANLDE_PATCH_STYLE_FAILURE",
  HANLDE_PATCH_STYLE_SUCCESS = "THEME_MANAGEMENT/HANLDE_PATCH_STYLE_SUCCESS",
  HANLDE_FIRST_FETCH_FAILURE = "THEME_MANAGEMENT/HANLDE_FIRST_FETCH_FAILURE",
  HANLDE_FIRST_FETCH_SUCCESS = "THEME_MANAGEMENT/HANLDE_FIRST_FETCH_SUCCESS",
  APPLY_FONT_TO_SECTION = "THEME_MANAGEMENT/APPLY_FONT_TO_SECTION",
  HANDLE_APPLY_FONT_TO_SECTION_SUCCESS = "THEME_MANAGEMENT/HANDLE_APPLY_FONT_TO_SECTION_SUCCESS",
  HANDLE_APPLY_FONT_TO_SECTION_FAILURE = "THEME_MANAGEMENT/HANDLE_APPLY_FONT_TO_SECTION_FAILURE",
  LOAD_ORG_FONT_FAMILIES = "THEME_MANAGEMENT/LOAD_ORG_FONT_FAMILIES",
  HANDLE_LOAD_ORG_FONT_FAMILIES_FAILURE = "THEME_MANAGEMENT/HANDLE_LOAD_ORG_FONT_FAMILIES_FAILURE",
  HANDLE_LOAD_ORG_FONT_FAMILIES_SUCCESS = "THEME_MANAGEMENT/HANDLE_LOAD_ORG_FONT_FAMILIES_SUCCESS",
  PATCH_ORG = "THEME_MANAGEMENT/PATCH_ORG",
  HANDLE_PATCH_ORG_FAILURE = "THEME_MANAGEMENT/HANDLE_PATCH_ORG_FAILURE",
  HANDLE_PATCH_ORG_SUCCESS = "THEME_MANAGEMENT/HANDLE_PATCH_ORG_SUCCESS",
  UPDATE_STYLES = "THEME_MANAGEMENT/UPDATE_STYLES",
  MOUNT = "THEME_MANAGEMENT/MOUNT",
  UNMOUNT = "THEME_MANAGEMENT/UNMOUNT",
}

export interface IAddNewLogoPayload {
  files: File[] | null;
  link: string | null;
  style: IStyle;
}

export enum FontSection {
  HEADER = "header",
  BODY = "body",
  MONOSPACE = "monospace",
}

export interface IApplyFontToSectionPayload {
  section: FontSection;
  fontOption: {
    name: string;
    ffmId: string | null;
  };
  style: IStyle;
}

export interface IFirstFetchPayload {
  style: IStyle;
  organization: ICompleteOrganization;
}

export type StyleLocation = "Title" | "LessCode" | "ColorPickers" | "Fonts" | "Logo" | null;

export interface IPatchStylePayload {
  location: StyleLocation;
  patch: IPatchPayload;
}

export const mount = createAction<string>(Action.MOUNT);
export const unmount = createAction<void>(Action.UNMOUNT);
export const handleFirstFetchFailure = createAction<{ message: string }>(Action.HANLDE_FIRST_FETCH_FAILURE);
export const handleFirstFetchSuccess = createAction<IFirstFetchPayload>(Action.HANLDE_FIRST_FETCH_SUCCESS);
export const patchStyle = createAction<IPatchStylePayload>(Action.PATCH_STYLE);
export const handlePatchStyleFailure = createAction<{ message: string }>(Action.HANLDE_PATCH_STYLE_FAILURE);
export const handlePatchStyleSuccess = createAction<IStyle>(Action.HANLDE_PATCH_STYLE_SUCCESS);
export const addNewLogo = createAction<IAddNewLogoPayload>(Action.ADD_NEW_LOGO);
export const handleAddNewLogoSuccess = createAction<void>(Action.HANDLE_ADD_NEW_LOGO_SUCCESS);
export const handleAddNewLogoFailure = createAction<{ message: string }>(Action.HANDLE_ADD_NEW_LOGO_FAILURE);
export const applyFontToSection = createAction<IApplyFontToSectionPayload>(Action.APPLY_FONT_TO_SECTION);
export const handleApplyFontToSectionFailure = createAction<{
  message: string;
}>(Action.HANDLE_APPLY_FONT_TO_SECTION_FAILURE);
export const handleApplyFontToSectionSuccess = createAction<void>(Action.HANDLE_APPLY_FONT_TO_SECTION_SUCCESS);
export const loadOrgFontFamilies = createAction<void>(Action.LOAD_ORG_FONT_FAMILIES);
export const handleLoadOrgFontFamiliesFailure = createAction<{
  message: string;
}>(Action.HANDLE_LOAD_ORG_FONT_FAMILIES_FAILURE);
export const handleLoadOrgFontFamiliesSuccess = createAction<IFontFamily[]>(
  Action.HANDLE_LOAD_ORG_FONT_FAMILIES_SUCCESS
);
export const patchOrganization = createAction<IPatchPayload>(Action.PATCH_ORG);
export const handlePatchOrganizationFailure = createAction<{ message: string }>(Action.HANDLE_PATCH_ORG_FAILURE);
export const handlePatchOrganizationSuccess = createAction<ICompleteOrganization>(Action.HANDLE_PATCH_ORG_SUCCESS);
export const updateStyles = createAction<void>(Action.UPDATE_STYLES);
export const dismissPatchAlert = createAction<void>(Action.DISMISS_PATCH_ALERTS);
